<template>
  <v-form ref="form" class="app-form" v-bind="$attrs" v-on="$listeners">
    <div class="app-form__fields">
      <slot />
    </div>

    <div v-if="$slots.actions" class="app-form__actions">
      <slot name="actions" />
    </div>
  </v-form>
</template>

<script>
export default {
  name: 'AppForm',

  methods: {
    validate() {
      return this.$refs.form.validate()
    },

    reset() {
      return this.$refs.form.reset()
    },

    resetValidation() {
      return this.$refs.form.resetValidation()
    },
  },
}
</script>

<style scoped>
.app-form__fields {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.app-form__actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
}
</style>
